export default __webpack_public_path__ + "static/media/group-option-eye-selected.7da4bc25.svg";